import { __rest } from "tslib";
import * as React from 'react';
import { Divider } from '../Divider';
export var OptionsMenuSeparator = function OptionsMenuSeparator(_a) {
  var _a$component = _a.component,
      component = _a$component === void 0 ? 'li' : _a$component,
      props = __rest(_a, ["component"]);

  return React.createElement(Divider, Object.assign({
    component: component
  }, props));
};